import React, { useState, useCallback, useEffect } from 'react';
import css from './ShopSettingsForm.module.css';
import { Icons, IconSpinner } from '../../../components';
import { updateProfile } from '../../ProfileSettingsPage/ProfileSettingsPage.duck';
import debounce from 'lodash/debounce';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

const BioSection = ({ input: { value, onChange }, intl, dispatch }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [bioError, setBioError] = useState('');
  const [updateBioInProgress, setUpdateBioInProgress] = useState(false);
  // Debounced update function to limit API calls
  const debouncedUpdateBio = useCallback(
    debounce(async bio => {
      setUpdateBioInProgress(true);
      if (bio && bio.length > 160) {
        setBioError(intl.formatMessage({ id: 'BioSection.error' }));
        return;
      }
      try {
        await dispatch(updateProfile({ bio: bio || '' }));
        setBioError('');
      } catch (error) {
        setBioError(intl.formatMessage({ id: 'BioSection.updateError' }));
      } finally {
        setUpdateBioInProgress(false);
      }
    }, 1000), // 1000ms debounce delay
    [dispatch, intl]
  );

  // Effect to trigger update when value changes during editing
  useEffect(() => {
    if (isEditing) {
      debouncedUpdateBio(value);
    }
    return () => {
      debouncedUpdateBio.cancel(); // Cleanup on unmount
    };
  }, [value, isEditing, debouncedUpdateBio]);

  const toggleEdit = () => {
    if (isEditing) {
      // Optionally confirm save or just exit edit mode
      setIsEditing(false);
    } else {
      setIsEditing(true);
      setBioError(''); // Clear error when starting edit
    }
  };
  const iconMap = {
    inProgress: <IconSpinner />,
    editing: <Icons name="cross" />,
    default: <Icons name="pencil" />,
  };

  const shouldShowEditIcon = () => {
    if (updateBioInProgress) return iconMap.inProgress;
    if (isEditing) return iconMap.editing;
    return iconMap.default;
  };
  return (
    <div className={css.bioSection}>
      <div className={css.bioTextareaWrapper}>
        <span
          className={css.editIcon}
          onClick={toggleEdit}
          aria-label={isEditing ? 'Save and exit edit' : 'Edit bio'}
        >
          {shouldShowEditIcon()}
        </span>
        <textarea
          className={classNames(css.bioTextarea, isEditing ? css.activeTextarea : null)}
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          placeholder={intl.formatMessage({ id: 'BioSection.placeholder' })}
          maxLength={160}
          disabled={!isEditing}
        />
        {/* {isEditing ? null : (
          <span className={css.addBioPlaceholder}>
            <FormattedMessage id="BioSection.addBio" defaultMessage="Add a Bio" />
          </span>
        )} */}
      </div>
      <div className={css.bioControls}></div>
      <span className={css.charCount}>
        <FormattedMessage id="BioSection.charCount" values={{ count: value ? value.length : 0 }} />
      </span>
      {bioError && <p className={css.error}>{bioError}</p>}
    </div>
  );
};

export default BioSection;
